import {
  faAngleDown,
  faArrowDown,
  faClose,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

const CategoryDropDown = ({
  categories,
  value,
  placeholder,
  onChange,
  deleteCategory,
}) => {
  const [modal, setModal] = useState(false);
  const [change, setChange] = useState(false);

  return (
    <>
      <div
        style={{
          width: "100%",
          height: "fit-content",
          display: "flex",
          flexDirection: "column",
          gap: "5px",
        }}
      >
        <p>Category</p>
        <div
          style={{
            width: "100%",
            height: "50px",
            borderRadius: "10px",
            border: "1px solid grey",
            display: "flex",
            alignItems: "center",
            padding: change ? "0px" : "10px",
            cursor: "pointer",
            position: "relative",
          }}
          onClick={() => setModal(true)}
        >
          {change ? (
            <>
              <input
                type="text"
                style={{
                  flex: 1,
                  height: "100%",
                  borderRadius: "10px",
                  border: "none",
                  outline: "none",
                  padding: "10px",
                  fontSize: ".9rem",
                }}
                value={value}
                placeholder="Enter new category value"
                onChange={(e) => onChange(e.target.value)}
              />
              <FontAwesomeIcon
                icon={faClose}
                style={{
                  color: "var(--brand-color)",
                  height: "50%",
                  marginRight: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  onChange("");
                  setModal(false);
                  setChange(false);
                }}
              />
            </>
          ) : (
            <>
              {value || placeholder}
              <FontAwesomeIcon
                icon={faAngleDown}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
              {modal && (
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    maxHeight: "300px",
                    background: "white",
                    top: "110%",
                    border: ".5px solid lightgrey",
                    left: 0,
                    zIndex: "1000",
                    overflowY: "auto",
                  }}
                >
                  {categories.map((val, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          padding: "10px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        className="on_hover_light_blue"
                        onClick={(e) => {
                          e.stopPropagation();
                          onChange(val.categoryName);
                          setModal(false);
                        }}
                      >
                        <p style={{ flex: 1 }}>{val.categoryName}</p>
                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{ cursor: "pointer", color: "red" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteCategory(val._id);
                          }}
                        />
                      </div>
                    );
                  })}
                  <div
                    style={{
                      color: "var(--brand-color)",
                      padding: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                    className="on_hover_light_blue"
                    onClick={(e) => {
                      e.stopPropagation();
                      setModal(false);
                      setChange(true);
                      onChange("");
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                    Add New Value
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {modal && (
        <div
          style={{
            position: "fixed",
            height: "100vh",
            width: "100vw",
            top: 0,
            left: 0,
            zIndex: "100",
          }}
          onClick={() => setModal(false)}
        ></div>
      )}
    </>
  );
};

export default CategoryDropDown;
